export const content = `
<p>Curățenia de întreținere reprezintă fundamentul unui mediu sănătos, fie că vorbim despre căminul tău sau despre sediul firmei tale. Spre deosebire de o intervenție radicală, aceasta funcționează ca un sistem de prevenție, asigurându-se că murdăria nu are timp să se fixeze.</p>

<div style="background-color: #f7f9fc; border-left: 4px solid #1a73e8; padding: 1.5rem; margin: 2rem 0; border-radius: 0 8px 8px 0;">
  <p style="font-weight: 700; margin-bottom: 0.8rem; color: #1d2a3a;">TL;DR — Rezumat rapid:</p>
  <ul style="list-style-type: none; padding-left: 0; margin-bottom: 0; line-height: 1.8;">
    <li><strong>Obiectiv central:</strong> Păstrarea unui nivel constant de igienă și ordine prin acțiuni repetitive.</li>
    <li><strong>Arie de acoperire:</strong> Se concentrează pe zonele de trafic și suprafețele care acumulează praf zilnic.</li>
    <li><strong>Eficiență:</strong> Previne degradarea materialelor și reduce necesitatea intervențiilor generale costisitoare.</li>
    <li><strong>Standard profesional:</strong> Implică utilizarea de soluții de curățare ecologice și tehnici care nu perturbă activitatea cotidiană.</li>
  </ul>
</div>

<div style="background-color: #f7f9fc; border-left: 4px solid #1a73e8; padding: 1.5rem; margin: 2rem 0; border-radius: 0 8px 8px 0;">
  <p style="font-weight: 700; margin-bottom: 0.8rem; color: #1d2a3a;">Cuprins articol:</p>
  <ul style="list-style-type: none; padding-left: 0; margin-bottom: 0; line-height: 1.8;">
    <li><a href="#ce-include" style="color: #1a73e8; text-decoration: none; font-weight: 600;">1. Ce include, concret, un pachet de curățenie de întreținere?</a></li>
    <li><a href="#analiza-comparativa" style="color: #1a73e8; text-decoration: none; font-weight: 600;">2. Analiză Comparativă: Întreținere vs. Generală</a></li>
    <li><a href="#studiu-de-caz" style="color: #1a73e8; text-decoration: none; font-weight: 600;">3. Studiu de caz: Eficiența curățeniei de întreținere la birou</a></li>
    <li><a href="#cum-alegi-frecventa" style="color: #1a73e8; text-decoration: none; font-weight: 600;">4. Cum alegi frecvența potrivită?</a></li>
    <li><a href="#faq" style="color: #1a73e8; text-decoration: none; font-weight: 600;">5. Întrebări frecvente (FAQ)</a></li>
  </ul>
</div>

<h2 id="ce-include">Ce include, concret, un pachet de curățenie de întreținere?</h2>
<p>O firmă profesionistă precum Doral Cleaning abordează acest serviciu printr-o listă riguroasă de activități menite să împrospăteze spațiul:</p>
<ul>
  <li><strong>Igienizarea Pardoselilor:</strong> Aspirarea completă și spălarea cu detergenți adaptați tipului de suprafață (parchet, granit sau gresie).</li>
  <li><strong>Deprafuirea Suprafețelor:</strong> Curățarea mobilierului, aparatelor electronice și a obiectelor de decor la nivelul accesibil.</li>
  <li><strong>Dezinfectarea Zonelor Sanitare:</strong> Curățarea chiuvetelor, a toaletelor și a oglinzilor, asigurând un mediu steril în punctele critice.</li>
  <li><strong>Întreținerea Bucătăriei:</strong> Ștergerea exterioară a electrocasnicelor, curățarea blaturilor și a zonei de luat masa.</li>
  <li><strong>Gestiunea Deșeurilor:</strong> Colectarea gunoiului din toate spațiile și înlocuirea sacilor menajeri.</li>
</ul>

<h2 id="analiza-comparativa">Analiză Comparativă: Întreținere vs. Generală</h2>
<div style="overflow-x: auto; margin: 2rem 0;">
  <table style="width: 100%; border-collapse: collapse; text-align: left; font-size: 0.95rem;">
    <thead>
      <tr style="background-color: #f1f5f9; border-bottom: 2px solid #cbd5e1;">
        <th style="padding: 12px; font-weight: 700;">Caracteristică</th>
        <th style="padding: 12px; font-weight: 700;">Curățenie de Întreținere</th>
        <th style="padding: 12px; font-weight: 700;">Curățenie Generală</th>
      </tr>
    </thead>
    <tbody>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;">Frecvență recomandată</td>
        <td style="padding: 12px;">Zilnic sau Săptămânal</td>
        <td style="padding: 12px;">O dată la 3-6 luni</td>
      </tr>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;">Durata intervenției</td>
        <td style="padding: 12px;">2 - 4 ore (în medie)</td>
        <td style="padding: 12px;">8 - 12 ore (profundă)</td>
      </tr>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;">Grad de detaliu</td>
        <td style="padding: 12px;">Suprafețe vizibile și zone de contact</td>
        <td style="padding: 12px;">În spatele mobilierului, interiorul dulapurilor</td>
      </tr>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;">Cost estimat</td>
        <td style="padding: 12px;">Redus (ideal prin abonament)</td>
        <td style="padding: 12px;">Ridicat (intervenție unică)</td>
      </tr>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;">Impact vizual</td>
        <td style="padding: 12px;">Menținerea ordinii existente</td>
        <td style="padding: 12px;">Transformare radicală a spațiului</td>
      </tr>
    </tbody>
  </table>
</div>

<h2 id="studiu-de-caz">Studiu de caz: Eficiența curățeniei de întreținere la birou</h2>
<p><strong>Context:</strong> O companie cu 20 de angajați ocupă un spațiu de 200 mp. În absența unui serviciu de întreținere, angajații pierd în medie 15 minute zilnic pentru a-și organiza spațiul de lucru.</p>
<p><strong>Soluția Doral Cleaning:</strong> Implementarea unui abonament de 3 vizite pe săptămână, realizate dimineața devreme, înainte de începerea programului.</p>
<p><strong>Rezultate obținute:</strong></p>
<ul>
  <li><strong>Productivitate:</strong> Eliminarea celor 15 minute de haos vizual crește randamentul echipei.</li>
  <li><strong>Sănătate:</strong> Reducerea prafului în suspensie a dus la scăderea sesizărilor de alergii sau disconfort ocular.</li>
  <li><strong>Economie:</strong> Costul anual al curățeniei generale a scăzut cu 35%, deoarece mochetele și suprafețele au rămas într-o stare excelentă mult mai mult timp.</li>
</ul>

<h2 id="cum-alegi-frecventa">Cum alegi frecvența potrivită?</h2>
<ul>
  <li><strong>Apartamente/Vile:</strong> O ședință săptămânală este suficientă pentru a păstra aspectul de "nou".</li>
  <li><strong>Birouri mici (sub 10 angajați):</strong> 2 vizite pe săptămână.</li>
  <li><strong>Spații comerciale/Showroom-uri:</strong> Curățenie de întreținere zilnică pentru a proteja imaginea brandului.</li>
</ul>

<h2 id="faq">Întrebări frecvente (FAQ)</h2>
<p><strong>Pot solicita curățenie de întreținere în timpul programului de lucru?</strong><br/>
Da, echipele noastre sunt instruite să lucreze discret, folosind echipamente cu nivel redus de zgomot.</p>
<p><strong>Este nevoie să furnizez eu soluțiile de curățare?</strong><br/>
Nu. Doral Cleaning vine echipat cu toți detergenții profesionali și ustensilele necesare.</p>

<div style="background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%); border-radius: 12px; padding: 2rem; margin: 2.5rem 0; text-align: center; color: #fff;">
  <p style="font-size: 1.15rem; font-weight: 600; margin-bottom: 0.5rem;">Cere o ofertă personalizată!</p>
  <p style="margin-bottom: 1.2rem; opacity: 0.92;">Dacă dorești ca spațiul tău să rămână mereu curat, igienizat și primitor, contactează Doral Cleaning pentru o ofertă personalizată adaptată nevoilor tale.</p>
  <a href="/contact-curatenie" style="background:#fff; color:#1a73e8; font-weight:700; padding:0.65rem 1.75rem; border-radius:8px; text-decoration:none; display:inline-block;">Contactează-ne</a>
</div>
`;

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Ce include curatenia de intretinere?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Include aspirarea si spalarea pardoselilor, stergerea prafului de pe suprafetele accesibile, igienizarea bailor, a bucatariei si colectarea gunoiului."
      }
    },
    {
      "@type": "Question",
      "name": "Pot solicita curățenie de întreținere în timpul programului de lucru?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Da, echipele noastre sunt instruite să lucreze discret, folosind echipamente cu nivel redus de zgomot."
      }
    },
    {
      "@type": "Question",
      "name": "Este nevoie să furnizez eu soluțiile de curățare?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Nu. Doral Cleaning vine echipat cu toți detergenții profesionali și ustensilele necesare."
      }
    }
  ]
};
